<template>
  <el-dialog
    title="手写签名"
    width="600px"
    append-to-body
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <VueSignature ref="sign" height="300" width="550" />
    <span slot="footer" class="dialog-footer">
      <el-button type="danger" @click="$refs.sign.clear()">清除</el-button>
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import VueSignature from "vue-signature-simple";
import { current } from "@szgc/plt-core-v2";
import { updateUserConfig } from "../../../api";
export default {
  name: "handSign",
  components: {
    VueSignature
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    show() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.sign.clear();
      });
    },
    async onSubmit() {
      const signImg = this.$refs.sign.getSignature("image/png");
      const { success } = await updateUserConfig(current.userId, {
        bmName: "taoHong",
        content: signImg
      });
      if (success) {
        this.visible = false;
        this.$emit("submit", signImg);
      }
    }
  }
};
</script>

<style scoped></style>
